import _ from 'lodash'
import { decryptUrlParams } from './action/explorer'
import { getSavedUrls } from '../redux/api/notes'
import { S3ServiceException } from '@aws-sdk/client-s3'
import { Auth } from 'aws-amplify'


/**
 * Read the URL parameters and get the network object.
 * @param {object} userDetails 
 * @param {string} params 
 * @returns The network object (nodes and edges)
 */
export const getNetworkFromUrl = async (userDetails) => {
  console.log("Getting network data from URL.")

  var params = await getCleanParamsFromUrl(userDetails)

  console.log("Params", params)

  // 'Decoded' in this context refers to splitting the objects in the params
  // which are divided by '*&*'
  const decodedParams = params.split('*&*')
  const contact = []
  const customer = []
  const unlinked = []
  decodedParams.forEach((item) => {
    if (item.includes('=')) {
      const data = item.split('=')
      if (data[0] === 'unlinked') {
        unlinked.push(...data[1].split(','))
      } else {
        contact.push(data[0].replace('%', ' '))
        customer.push(...data[1].split(','))
      }
    } else {
      contact.push(item.replace('%', ' '))
    }
  })
  return { contact: _.uniq(contact), customer: _.uniq(customer), unlinked: _.uniq(unlinked) }
}

/**
 * Get the clean network data params.
 * @param {object} userDetails 
 * @returns The network data params.
 */
export const getCleanParamsFromUrl = async (userDetails) => {
  console.log("Getting clean params from URL. ")

  const url = window.location.href && window.location.href
  console.log("Current path: ", url)

  var params = url.includes('/explorer?params=') && url.split('/explorer?params=')[1]

  // The params could be a hash, an encrypted string, or just network data.
  // If the params is a hash...
  if (params.startsWith('WdV101')) {
    console.log("The URL contains a hash.")
    var encryptedString = await getSavedEncriptedParams(userDetails, params)
    params = decryptUrlParams(encryptedString)
  } else if (params.startsWith('WdVEnc')) {
    console.log("The URL contains encrypted network data.")
    params = decryptUrlParams(params)
  }

  return params.replace("%20", " ");
}

/**
 * Get the encrypted network params for the corresponding saved network.
 * Obviously this should be a direct endpoint...
 * @param {string} hash 
 */
export const getSavedEncriptedParams = async (userDetails, hash) => {
  console.log("Getting saved encrypted params: Hash key: ", hash)

  var credentials = await Auth.currentCredentials();
  const savedUrls = await getSavedUrls(credentials.identityId)
  for (var savedUrl of savedUrls) {
    if (savedUrl.hash && savedUrl.hash == hash) {
      console.log("Found the URL by hash lookup.", savedUrl.url)
      return decodeURIComponent(savedUrl.url)
    }
  }

  throw new Error('No saved network matched the hash!', hash)
}